import { Suspense, lazy } from 'react';
import type { Components } from 'react-markdown';

import type { TypesetProps } from '@spotify/confidence-core-react';

const MarkdownContentInner = lazy(() => import('./MarkdownContentInner'));

export type MarkdownContentProps = {
  children: string;
  className?: string;
  components?: Components;
  size?: TypesetProps['size'];
};

export const MarkdownContent = ({
  children,
  className,
  components,
  size,
}: MarkdownContentProps) => (
  <Suspense fallback={null}>
    <MarkdownContentInner
      className={className}
      components={components}
      size={size}
    >
      {children}
    </MarkdownContentInner>
  </Suspense>
);
